import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { useContext } from "react";
import { ProductContext } from "./../../../store";
import { PostData } from "../../../services/FetchData";
import { toast } from "react-toastify";
import { Input, Spinner } from "reactstrap";

const EditFilterGeneral = () => {
	const { applySortingToValues } = useContext(ProductContext)
	const [editSaveLoader, setEditSaveLoader] = useState(false);
	const [currentPage, setCurrentPage] = useState(0);
	const [itemsPerPage, setItemsPerPage] = useState(20);
	const [totalItems, setTotalItems] = useState(0);
	const [paginatedData, setPaginatedData] = useState([]);
	const [searchTerm, setSearchTerm] = useState("");
	const [isEditMode, setIsEditMode] = useState(false);
	const [editableData, setEditableData] = useState([]);
	const { currentWebsiteId, filterValues, setFilterValues, currentFilter } = useContext(ProductContext)
	const [dropdownValues, setDropdownValues] = useState([])
	const [colorFamilies, setColorFamilies] = useState([])


	useEffect(() => {
		if (isEditMode && editableData.length === 0 && filterValues.length > 0) {
			setEditableData([...filterValues])
		}
	}, [isEditMode, filterValues, editableData.length]);

	const applySorting = (data) => {
		if (!data || data.length === 0) return data;

		const sorted = applySortingToValues(data, currentFilter.sortBy);
		return sorted;
	};

	useEffect(() => {
		if (currentFilter.appearance === "color") {
			fetchColorFamilies()
		}
	}, [currentFilter])

	useEffect(() => {
		const dataSource = isEditMode ? editableData : filterValues

		const sortedData = isEditMode ? dataSource : applySorting(dataSource);

		const filteredData = sortedData.filter(
			(item) =>
				(item.value1 || item.value || "")
					.toLowerCase()
					.includes(searchTerm.toLowerCase()) ||
				(item.displayName || "")
					.toLowerCase()
					.includes(searchTerm.toLowerCase())
		);

		const startIndex = currentPage * itemsPerPage;
		const endIndex = startIndex + itemsPerPage;
		const currentData = filteredData.slice(startIndex, endIndex);

		setPaginatedData(currentData);
		setTotalItems(filteredData.length);
	}, [
		currentPage,
		itemsPerPage,
		searchTerm,
		isEditMode,
		editableData,
		filterValues,
	]);

	const fetchColorFamilies = () => {
		PostData("ms1", "api/v1/filters/getAllColorFamilies", { websiteId: currentWebsiteId }).then(result => {
			if (result !== "Invalid" && result !== "undefined") {
				if (result.status === "success") {
					let colorFamilies = result.data.colorFamilies
					setDropdownValues(colorFamilies.map(family => family.familyName))
					setColorFamilies(colorFamilies)
				}
			}
		})
	}

	const handlePageChange = ({ selected }) => {
		setCurrentPage(selected);
	}

	const handleEditValues = () => {
		setIsEditMode(true)
		// Use filterValues from props
		const dataSource = filterValues
		setEditableData([...dataSource])
	}

	const handleCancelEdit = () => {
		setIsEditMode(false)
		setEditableData([])
	};

	const getMappedColor = (value) => {
		value	= value.toLowerCase()
		if (!colorFamilies || !Array.isArray(colorFamilies)) return "Unmapped";

		let mappedFamily = colorFamilies.find(fam => {
			// If colorsIncludes is present on the family, check if value is in it (comma-separated string)
			let colors	= []
			if (fam.colorsIncluded) {
				colors = fam.colorsIncluded.split(",").map(c => c.trim());
			}
			console.log(colors, fam.familyCode)
			return colors.includes(value) || fam.familyCode === value;
			
		});

		if (mappedFamily) {
			return mappedFamily.familyName || "Unmapped";
		}

		return "Unmapped";
	}

	const handleSaveEdit = () => {
		setEditSaveLoader(true)
		// INSERT_YOUR_CODE
		// Compare editableData with filterValues and only pass updated values to API
		const getUpdatedItems = (original, edited) => {
			return edited.filter(editedItem => {
				const origItem = original.find(item => item.filterValueId === editedItem.filterValueId);
				// If no original, treat as new
				if (!origItem) return true;
				// Shallow compare all keys except filterValueId
				const keys = Object.keys(editedItem).filter(k => k !== 'filterValueId');
				return keys.some(key => editedItem[key] !== origItem[key]);
			});
		};

		const updatedValues = getUpdatedItems(filterValues, editableData);
		if( updatedValues.length > 0 ){
			PostData("ms1", "api/v1/filters/saveFilterValues", { websiteId: currentWebsiteId, filterValues: updatedValues }).then(response => {
				if (response !== "Invalid" && response !== "undefined") {
					if (response.status === "success") {
						setIsEditMode(false);
						setFilterValues(JSON.parse(JSON.stringify(editableData)))
						setEditableData([])
					} else if (response.status === "failure") {
						toast.error(response.message)
					} else {
						toast.error(response.message.message)
					}
				}
				setEditSaveLoader(false)
			})
		}else{
			setEditSaveLoader(false)
			setIsEditMode(false);
			setEditableData([])
		}
	}

	const handleFilterValue = (id, newValue, index) => {
		console.log(id, newValue)
		setEditableData((prev) =>
			prev.map((item) =>
				item.filterValueId === id ? { ...item, [index]: newValue } : item
			)
		);
	}

	return (
		<div className="editFilterGeneral">
			{/* Values Management Section */}
			<div className="editFilterPaginationSection">
				{/* Top Controls */}
				<div className="editFilterControls">
					<div className="editFilterSearch">
						<Input
							type="text"
							placeholder="Search values"
							value={searchTerm}
							onChange={(e) => setSearchTerm(e.target.value)}
							className="editFilterSearchInput"
						/>
						{/* <button className="editFilterSearchButton" onClick={handleSearch}>
							Search
						</button> */}
					</div>

					<div className="editFilterActionButtons">
						{isEditMode ? (
							<>
								<button
									className="editFilterCancelButton"
									onClick={handleCancelEdit}
								>
									Cancel
								</button>
								<button
									className="editFilterSaveButton"
									onClick={handleSaveEdit}
									disabled={editSaveLoader}
								>
									{editSaveLoader ? <><Spinner size={"sm"} /> Saving...</> : "Save"}
								</button>
							</>
						) : (
							<>
								<button
									className="editFilterEditValuesButton"
									onClick={handleEditValues}
								// disabled={selectedItems.length === 0}
								>
									Edit values
								</button>
							</>
						)}
					</div>
				</div>

				{/* Edit Mode Indicator */}
				{isEditMode && (
					<div
						className="editModeIndicator"
						style={{
							backgroundColor: "#e3f2fd",
							border: "1px solid #2196f3",
							borderRadius: "4px",
							padding: "8px 12px",
							marginBottom: "16px",
							color: "#1976d2",
							fontSize: "14px",
							fontWeight: "500",
						}}
					>
						<i className="fa-solid fa-edit" style={{ marginRight: "8px" }}></i>
						Edit Mode Active - You can now modify display names and statuses
						{/* {currentFilter?.sortBy === "manual" && (
							<span style={{ marginLeft: "16px", fontSize: "12px" }}>
								<i
									className="fa-solid fa-grip-vertical"
									style={{ marginRight: "4px" }}
								></i>
								Drag and drop to reorder items
							</span>
						)} */}
					</div>
				)}

				{/* Values Table */}
				<div className="editFilterTable">
					<table className="table editFilterPlainTable">
						<thead>
							<tr>
								{/* <th className="checkbox-column">
									<input
										type="checkbox"
										checked={
											selectedItems.length === paginatedData.length &&
											paginatedData.length > 0
										}
										onChange={handleSelectAll}
										className="editFilterCheckbox"
									/>
								</th> */}
								{currentFilter?.sortBy === "manual" && (
									<th>Pos</th>
								)}
								<th>Value</th>
								<th>{currentFilter.appearance === "color" ? "Color Family" : "Display name"}</th>
								<th>Status</th>
							</tr>
						</thead>
						<tbody>
							{paginatedData.map((item) => (
								<tr key={item.filterValueId}>
									{/* <td className="checkbox-column">
										<input
											type="checkbox"
											checked={selectedItems.includes(item.filterValueId)}
											onChange={() => handleItemSelect(item.filterValueId)}
											className="editFilterCheckbox"
										/>
									</td> */}
									{currentFilter?.sortBy === "manual" && (
										<td>
											{isEditMode ? (
												<input
													type="text"
													value={item.pos || 1000}
													onChange={(e) =>
														handleFilterValue(item.filterValueId, e.target.value, "pos")
													}
													className="editFilterInlineInput"
													placeholder="Enter Position"
													style={{
														width: "100%",
														padding: "6px 10px",
														border: "1px solid #ddd",
														borderRadius: "4px",
														fontSize: "14px",
														transition: "border-color 0.2s ease",
														outline: "none",
													}}
													onFocus={(e) =>
														(e.target.style.borderColor = "#2196f3")
													}
													onBlur={(e) =>
														(e.target.style.borderColor = "#ddd")
													}
												/>
											) : (
												item.pos
											)}
										</td>
									)}
									<td>{item.value1 || item.value}</td>
									<td>
										{isEditMode ? (
											currentFilter.appearance !== "color" ? (
												<input
													type="text"
													value={item.displayName || ""}
													onChange={(e) =>
														handleFilterValue(item.filterValueId, e.target.value, "displayName")
													}
													className="editFilterInlineInput"
													placeholder="Enter display name"
													style={{
														width: "100%",
														padding: "6px 10px",
														border: "1px solid #ddd",
														borderRadius: "4px",
														fontSize: "14px",
														transition: "border-color 0.2s ease",
														outline: "none",
													}}
													onFocus={(e) =>
														(e.target.style.borderColor = "#2196f3")
													}
													onBlur={(e) =>
														(e.target.style.borderColor = "#ddd")
													}
												/>
											) : (
												<select
													value={item.displayName || ""}
													onChange={(e) =>
														handleFilterValue(item.filterValueId, e.target.value, "displayName")
													}
													className="editFilterInlineSelect"
													style={{
														width: "100%",
														padding: "6px 10px",
														border: "1px solid #ddd",
														borderRadius: "4px",
														fontSize: "14px",
														backgroundColor: "white",
														transition: "border-color 0.2s ease",
														outline: "none",
													}}
													onFocus={(e) =>
														(e.target.style.borderColor = "#2196f3")
													}
													onBlur={(e) =>
														(e.target.style.borderColor = "#ddd")
													}
												>
													<option value="">Unmapped</option>

													{dropdownValues.map((familyName) => (
														<option key={familyName} value={familyName}>
															{familyName}
														</option>
													))}
												</select>
											)
										) : (
											<>
												{/* {item.displayName} */}
												{currentFilter.appearance !== "color" ?
													item.displayName
													:
													<>
														{getMappedColor(item.value)}
													</>
												}
											</>
										)}
									</td>
									<td>
										{isEditMode ? (
											<select
												value={item.status}
												onChange={(e) =>
													handleFilterValue(item.filterValueId, e.target.value, "status")
												}
												className="editFilterInlineSelect"
												style={{
													width: "100%",
													padding: "6px 10px",
													border: "1px solid #ddd",
													borderRadius: "4px",
													fontSize: "14px",
													backgroundColor: "white",
													transition: "border-color 0.2s ease",
													outline: "none",
												}}
												onFocus={(e) =>
													(e.target.style.borderColor = "#2196f3")
												}
												onBlur={(e) => (e.target.style.borderColor = "#ddd")}
											>
												<option value={true}>Active</option>
												<option value={false}>Hidden</option>
											</select>
										) : (
											<span
												className={`status-badge ${item.status ? "active" : "hidden"}`}
											>
												{item.status ? "Active" : "Hidden"}
											</span>
										)}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>

				{/* Pagination */}
				{Math.ceil(totalItems / itemsPerPage) > 1 && (
					<div className="editFilterPagination">
						<ReactPaginate
							nextLabel=">"
							onPageChange={handlePageChange}
							pageRangeDisplayed={3}
							marginPagesDisplayed={2}
							pageCount={Math.ceil(totalItems / itemsPerPage)}
							previousLabel="<"
							pageClassName="page-item"
							pageLinkClassName="page-link"
							previousClassName="page-item"
							previousLinkClassName="page-link"
							nextClassName="page-item"
							nextLinkClassName="page-link"
							breakLabel="..."
							breakClassName="page-item"
							breakLinkClassName="page-link"
							containerClassName="pagination editFilterPaginationContainer"
							activeClassName="active"
							renderOnZeroPageCount={null}
							forcePage={currentPage}
						/>
					</div>
				)}
			</div>
		</div>
	);
};

export default EditFilterGeneral;
